import React, { useState } from 'react';
import { USER_ROLE } from '../../services/auth';

const VehicleHeader = ({
  search,
  count,
  onSearch,
  handleSearch,
  typeFilter,
  onTypeFilter,
  vehicleModeFilter,
  onVehicleModeFilter,
  dimensionFilter,
  onDimensionFilter,
  branchFilter,
  onBranchFilter,
  statusFilter,
  onStatusFilter,
  handleAdd,
  dimensions,
  vehicleTypes,
  branches,
  onClearSearch,
  onBack,
  vehicle,
  formName
}) => {
  const typeFilterName = vehicleTypes.filter(vh => vh.id == typeFilter).name;
  const dimensionName = dimensions.filter(dim => dim.id == dimensionFilter).dimension;
  const branchName = branches.filter(branch => branch?.id == branchFilter).name;
  const role = localStorage.getItem(USER_ROLE);
  const showBranches = role == 'admin';

  if (formName == 'add_edit') {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]"> {vehicle ? `Edit Vehicle(${vehicle.vehicle_code})` : "Add Vehicle"} </h1>
        <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
          <button
            onClick={onBack}
            className="bg-blue-600 text-white px-4 py-1.5 rounded text-sm hover:bg-blue-600"
          >
            {"< Go Back"}
          </button>
        </div>
      </div>
    );
  } else if (formName == 'expense') {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]">Vehicle Expense</h1>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
      <h1 className="text-xl font-bold uppercase text-[#293686]">Vehicles({count})</h1>
      <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
        <div className="relative flex border rounded overflow-hidden w-full md:w-64">
          <input
            value={search}
            onChange={onSearch}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
            placeholder="Search by vehicle number"
            className="px-3 py-1.5 text-sm w-full outline-none"
          />
          {/* Clear (X) button — appears only when there's text */}
          {search && (
            <button
              type="button"
              onClick={onClearSearch}
              className="absolute right-12 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              title="Clear"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
          <button
            onClick={handleSearch}
            className="bg-blue-600 px-3 text-white text-sm hover:bg-blue-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
              />
            </svg>
          </button>
        </div>
        <select
          value={typeFilterName}
          onChange={onTypeFilter}
          className="border px-3 py-1.5 text-sm rounded"
        >
          <option value="">All Types</option>
          {vehicleTypes.map(t => (
            <option key={t.id} value={t.name}>
              {t.name}
            </option>
          ))}
        </select>
        <select
          value={vehicleModeFilter}
          onChange={onVehicleModeFilter}
          className="border px-3 py-1.5 text-sm rounded"
        >
          <option value="">All Modes</option>
          <option value="own">Own</option>
          <option value="market">Market</option>
        </select>
        {/* <select
          value={dimensionName}
          onChange={onDimensionFilter}
          className="border px-3 py-1.5 text-sm rounded"
        >
          <option value="">All Dimensions</option>
          {dimensions.map(d => (
            <option key={d.id} value={d.dimension}>
              {d.dimension}
            </option>
          ))}
        </select> */}
        {showBranches && (
          <select
            value={branchName}
            onChange={onBranchFilter}
            className="border px-3 py-1.5 text-sm rounded"
          >
            <option value="">All Branches</option>
            {branches.map(b => (
              <option key={b.id} value={b.name}>
                {b.name}
              </option>
            ))}
          </select>
        )}
        <select
          value={statusFilter}
          onChange={onStatusFilter}
          className="border px-3 py-1.5 text-sm rounded"
        >
          <option value="All">All Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
        <button
          onClick={() => handleAdd('market')}
          className="bg-[#E91C24] text-white px-4 py-1.5 rounded text-sm hover:bg-[#E91C24]"
        >
          + Market Vehicle
        </button>
        <button
          onClick={() => handleAdd('own')}
          className="bg-[#E91C24] text-white px-4 py-1.5 rounded text-sm hover:bg-[#E91C24]"
        >
          + Own Vehicle
        </button>
      </div>
    </div>
  );
};

export default VehicleHeader;
